'use client';
import cn from 'classnames';
import Image from 'next/image';
import { CMSResponsiveImageData } from '@/components/builder/component-registry';

import './CMSResponsiveImage.style.scss';
import AspectRatioImage from '../AspectRatioImage/AspectRatioImage';

type CMSResponsiveImageProps = {
  className?: string;
  data: CMSResponsiveImageData;
  desktopImgClassName?: string;
  desktopImgMaintainAspectRatio?: boolean;
  mobileImgClassName?: string;
  mobileImgMaintainAspectRatio?: boolean;
};

function CMSResponsiveImage(props: CMSResponsiveImageProps) {
  const {
    className = '',
    desktopImgClassName = '',
    desktopImgMaintainAspectRatio = false,
    mobileImgClassName = '',
    mobileImgMaintainAspectRatio = false,
    data
  } = props;

  const { desktop, mobile } = data;

  return (
    <div className={cn('CMSResponsiveImage', className)}>
      {desktopImgMaintainAspectRatio ? (
        <AspectRatioImage
          className={cn('CMSResponsiveImage-desktop', desktopImgClassName)}
          src={desktop.image}
          alt={desktop.imageAltText}
          height={desktop.imageHeight}
          width={desktop.imageWidth}
        />
      ) : (
        <Image
          className={cn('CMSResponsiveImage-desktop', desktopImgClassName)}
          src={desktop.image}
          alt={desktop.imageAltText}
          height={desktop.imageHeight}
          width={desktop.imageWidth}
        />
      )}

      {mobileImgMaintainAspectRatio ? (
        <AspectRatioImage
          className={cn('CMSResponsiveImage-mobile', mobileImgClassName)}
          src={mobile.image}
          alt={mobile.imageAltText}
          height={mobile.imageHeight}
          width={mobile.imageWidth}
        />
      ) : (
        <Image
          className={cn('CMSResponsiveImage-mobile', mobileImgClassName)}
          src={mobile.image}
          alt={mobile.imageAltText}
          height={mobile.imageHeight}
          width={mobile.imageWidth}
        />
      )}
    </div>
  );
}

export default CMSResponsiveImage;
